export const isIncludesTerm = (searchWord: string, fieldVal: string) => {
  if (searchWord && fieldVal) {
    return fieldVal.toLowerCase().includes(searchWord.toLowerCase());
  }
  return false;
};
